import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Users, Plus } from "lucide-react";
import api from "@/lib/api";
import { CommunityCard } from "@/components/cards";
import { Loader, SectionHeader, EmptyState, Chip, PrimaryButton, PASSION_LABEL } from "@/components/ui-bits";

const PASSIONS = ["photography", "fitness-wellness", "art-creative", "music", "cooking", "writing"];

export default function Communities() {
  const [params, setParams] = useSearchParams();
  const passion = params.get("passion") || "";
  const [sort, setSort] = useState("popular");
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    const q = new URLSearchParams();
    if (passion) q.set("passion", passion);
    q.set("sort", sort);
    api.get(`/communities?${q}`).then((r) => setItems(r.data));
  }, [passion, sort]);

  const setPassion = (p) => { const np = new URLSearchParams(params); p ? np.set("passion", p) : np.delete("passion"); setParams(np); };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <SectionHeader eyebrow="Communities" title="Find your people"
        subtitle="Browse communities built around every passion — or start your own."
        action={<PrimaryButton as={Link} to="/create/community" data-testid="create-community-cta"><Plus className="h-4 w-4" />Create community</PrimaryButton>} />

      <div className="flex flex-wrap items-center gap-2 mb-8 overflow-x-auto pb-1">
        <Chip active={!passion} onClick={() => setPassion("")} data-testid="filter-all">All passions</Chip>
        {PASSIONS.map((p) => <Chip key={p} active={passion === p} onClick={() => setPassion(p)} data-testid={`filter-${p}`}>{PASSION_LABEL[p]}</Chip>)}
        <div className="ml-auto flex items-center gap-2">
          <Chip active={sort === "popular"} onClick={() => setSort("popular")} data-testid="sort-popular">Popular</Chip>
          <Chip active={sort === "newest"} onClick={() => setSort("newest")} data-testid="sort-newest">Newest</Chip>
        </div>
      </div>

      {!items ? <Loader /> : items.length ? (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="communities-grid">{items.map((c) => <CommunityCard key={c.id} c={c} />)}</div>
      ) : (
        <EmptyState icon={Users} title="No communities here yet" hint="Be the first to create a community for this passion."
          action={<PrimaryButton as={Link} to="/create/community">Create one</PrimaryButton>} />
      )}
    </div>
  );
}
